import axios from 'axios'
import { notify } from '../utils/helper'
import { getConfigDetails } from './config'

const axiosClient = axios.create()
const partner = window.location.toString().split('/')[3]

// Intercept request
axiosClient.interceptors.request.use(
  (request) => {
    const signInData = localStorage.getItem('sign_in')
    const signUpData = localStorage.getItem('sign_up')
    const userData = JSON.parse(signInData || signUpData || '{}')
    
    request.headers['Content-Type'] = 'application/json'
    userData?.access_token ? request.headers['Authorization'] = `Bearer ${userData?.access_token}` : '',
    request.headers['X-ClientSecret'] = getConfigDetails()?.CLIENT_SECRET || ''
    
    return request
  }
)

// Intercept response
axiosClient.interceptors.response.use(
  (response) => {
    const signInData = localStorage.getItem('sign_in')
    const signUpData = localStorage.getItem('sign_up')
    const userData = JSON.parse(signInData || signUpData || '{}')

    if ([200, 201, 202].includes(response?.status)) {
      return response.data
    }else if(response?.status == 401){
      if(userData?.access_token && userData?.access_token != null){
        notify('error', 'Session Expired, Please Login Again')
        localStorage.clear()
        sessionStorage.clear()
        setTimeout(() => {
          window.location.replace(`/${partner}`)
        }, 5000)
      }else{
        return	Promise.reject(response?.data)
      }
	}else{
		return	Promise.reject(response?.data)
	}
  },
  (error) => {
	const errorData = error.response ? error.response.data : { message: 'An unknown error occurred' }
  const signInData = localStorage.getItem('sign_in')
  const signUpData = localStorage.getItem('sign_up')
  const userData = JSON.parse(signInData || signUpData || '{}')
  
    if(error?.response?.status == 401){
      if(userData?.access_token && userData?.access_token != null){
        notify('error', 'Session Expired, Please Login Again')
        localStorage.clear()
        sessionStorage.clear()
        setTimeout(() => {
          window.location.replace(`/${partner}`)
        }, 3000)
      }else{
        return Promise.reject(errorData)    
      }
	}else{
		return Promise.reject(errorData)
	}
	
	
  }
)

// Set default headers
axiosClient.defaults.headers = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
}

// All requests will wait 1 min before timeout
axiosClient.defaults.timeout = 60000

export default axiosClient
